import React, { Component } from "react";
import { connect } from "react-redux";
import { Redirect } from "react-router";
import FirstLoginHoc from "./FirstLoginHoc";

export default function(ComposedComponent) {
  class AuthHoc extends Component {
    render() {
      return (
        <>
          {this.props.isAuthenticated ? (
            <ComposedComponent {...this.props} />
          ) : (
            <Redirect to="/" />
          )}
        </>
      );
    }
  }

  const mapStateToProps = state => {
    return {
      isAuthenticated: state.login.isLoggedIn
    };
  };
  return connect(mapStateToProps)(FirstLoginHoc(AuthHoc));
}
